export default __webpack_public_path__ + "static/project-slide-8-1248-765-a71fc9348996d29eb46ca3573145a263.jpg";